import {
  type ApproverConstructor,
  Approver,
} from '@webapp/core/entities/internal/Approver'
import {
  ExpenseApprovalActions,
  type ExpenseApprovalActionEnum,
} from '../enums/ExpenseApprovalActionEnum'

export interface ExpenseApprovalLogConstructor {
  id: number
  action: ExpenseApprovalActionEnum
  dateTime: Nullable<ISODateString>
  user: ApproverConstructor
}

export class ExpenseApprovalLog {
  readonly id: number
  readonly action: ExpenseApprovalActionEnum
  readonly dateTime: Nullable<ISODateString>
  readonly user: Approver

  constructor(data: ExpenseApprovalLogConstructor) {
    this.id = data.id
    this.action = data.action
    this.dateTime = data.dateTime || null

    this.user = new Approver(data.user)
  }

  get isDenyAction() {
    return this.action === ExpenseApprovalActions.DENY
  }

  get isFinalApprovedAction() {
    return this.action === ExpenseApprovalActions.FINAL_APPROVE
  }
}
